<template>
    <div>
        <v-btn color="success" title="Upload" fab :small="size=='small'" :large="size=='large'" @click="selectThumbnail">
            <v-icon>{{icon}}</v-icon>
            <input :id="'upload'" type="file" class="upload-input" ref="input" :accept="allowedFileExtensions" @change="onFilePicked" />
        </v-btn>
        <span>{{file.FileName}}</span>
        <v-btn fab small @click="reset" v-if="documentLoaded">
            <v-icon >mdi-cancel</v-icon>
        </v-btn>

    </div>
</template>

<script>
export default {
    props: {
        allowedFileExtensions: {
            type: String,
            default: ""
        },
        maxFileSizeMB: {
            type: Number,
            default: 4
        },
        size: {
            type: String,
            default: "small"
        },
        icon: {
            type: String,
            default: "backup"
        }
    },
    computed: {
        AllowedExtensionsArray() {
            if (this.allowedFileExtensions) {
                const cleanString = this.allowedFileExtensions.replace(/\s/g, '').replace(/\./g, '').toLowerCase();
                return cleanString.split(',');
            } else {
                return [];
            }
        },
        documentLoaded() {
            return this.file !== null && this.file !== undefined && this.file.FileData != null;
        }
    },
    data() {
        return {
            file:  { FileName: '', FileData: null,  FileBase64: null, ContentType: ''}
        };
    },
    methods: {
        async onFilePicked(e) {
            const self = this;
            const readFiles = e.target.files;
            if (readFiles && readFiles[0] !== undefined) {
                //Check file is larger than allowed
                if ((readFiles[0].size / 1024 / 1024) >= self.maxFileSizeMB) {
                    self.$emit('fileInvalid', `File can not exceed ${self.maxFileSizeMB}MB`);
                    return;
                } else {
                    // check extensions
                    const fileName = readFiles[0].name;
                    if (fileName.includes('.')) {
                        // file name contains a period
                        const stringParts = fileName.split('.');
                        if (stringParts && stringParts.length > 0) {
                            const extension = stringParts[stringParts.length - 1].trim().toLowerCase();
                            // check that extension is in list of allowed types
                            if (self.AllowedExtensionsArray.length === 0 || self.AllowedExtensionsArray.includes(extension)) {
                                // file extension is allowed
                            } else {
                                // extension not in allowed list
                                self.$emit('fileInvalid', `File format is invalid`);
                                alert("File format is invalid, it accepts " + self.AllowedExtensionsArray.join(",") +".")
                                return;
                            }
                        } else {
                            // error
                            self.reset();
                            self.$emit('fileInvalid', `File Error`);
                            return;
                        }
                    } else {
                        // no extension
                        self.reset();
                        self.$emit('fileInvalid', `File Error`);
                        return;
                    }
                }
                self.file.FileName = readFiles[0].name;
                if (!self.file.FileName) {
                    return;
                }
                self.file.FileData = readFiles[0];
                self.file.ContentType = readFiles[0].type;
                const b64 = await this.toBase64(readFiles[0]);
                self.file.FileBase64 = b64;
                self.$emit('fileSelected', self.file);
            } else {
                self.reset();
            }
        },
        toBase64(file){
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = (error) => reject(error);
            });
        },
        reset() {
            this.file =  { FileName: '', FileData: null,  FileBase64: null, ContentType: ''};
        },
        selectThumbnail() {
            this.$refs.input.click();
        }
    },
}
</script>

<style>
.upload-input {
  display: none;
}

</style>